import AudioPlayer from "./audio/audio";
import { AudioContainer } from "./container/container";
import { AudioHeader } from "./header/header";
import { ButtonContinue } from "./button-continue/button-continue";

export const Audiobook = {
  AudioPlayer,
  AudioHeader,
  AudioContainer,
  AudioBookContinue: ButtonContinue,
};
